export default function InfoSection({ title, description, image, reverse }) {
  const sectionStyle = {
    display: 'flex',
    flexDirection: reverse ? 'row-reverse' : 'row',
    alignItems: 'center',
    width: '100%',
    margin: '48px auto',
    border: '2px solid #1f6a0bff',
    borderRadius: '18px',
    background: 'white',
    boxSizing: 'border-box',
    overflow: 'hidden',
    minHeight: '260px',
    boxShadow: '0px 6px 36px rgba(36, 112, 139, 0.06)',
  };

  const imageStyle = {
    flex: '1 1 50%',
    height: '100%',
    maxHeight: '320px',
    width: '100%',
    background: '#279a10ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const imgTagStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: reverse ? "0 16px 16px 0" : "16px 0 0 16px",
  };

  const textStyle = {
    flex: '1 1 50%',
    padding: '40px 32px',
    minWidth: '300px',
    color: '#222',
  };

  const bulletPoints = [
    'First bullet point',
    'Second bullet point',
    'Third bullet point',
  ];

  return (
    <div style={sectionStyle}>
      <div style={imageStyle}>
        <img src={image} alt="info section" style={imgTagStyle} />
      </div>
      <div style={textStyle}>
        <h3 style={{ fontWeight: 'bold', marginBottom: '12px' }}>{title}</h3>
        <p style={{ marginBottom: '16px' }}>{description}</p>
        <ul>
          {bulletPoints.map((point, i) => (
            <li key={i} style={{ marginBottom: '10px', fontSize: '18px' }}>{point}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
